import styled from 'styled-components';
import { Button } from 'components';
import { Row } from 'antd';

export const ModalStyle = styled.div`
  .ant-modal-title {
    width: 100%;
  }
  .modal-chart {
    height: 500px;
  }
`;

export const RowText = styled(Row)`
  border-bottom: 1px solid #dddddd;
  text-align: center;
  padding: 8px 0;
`;

export const HeaderStyledChart = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 18px;
  width: 100%;
  justify-content: space-between;
  letter-spacing: 0;
  line-height: 27px;
  cursor: pointer;

  img {
    margin-right: 16px;
  }
`;

export const ButtonCsv = styled(Button)`
  height: 28px !important;
  min-width: 120px !important;
`;

export const ChartContentStyled = styled.section`
  padding-bottom: 24px;
  .text-x {
    padding-left: 2px;
    font-size: 12px;
    color: #818181;
  }
  .example-spin {
    margin: 20px 0;
    line-height: 400px;
    text-align: center;
  }
  .empty-chart {
    height: calc(100% - 20px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .menu-time-chart {
    border-bottom: 1px solid rgba(28, 75, 140, 0.1);
    margin: 0 !important;
  }
  .ant-menu-item-selected {
    color: #333333;
  }
  .ant-menu-item:hover {
    background-color: rgba(28, 75, 140, 0.1);
    color: #333333;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: rgba(28, 75, 140, 0.1);
  }
  .menu {
    border-right: none;
  }
  .menu-left {
    border-right: 1px solid #dddddd;
    padding-right: 8px;
    .text-left {
      padding: 8px 24px;
      border-bottom: 1px solid #dddddd;
      color: #666666;
    }
  }
  .text-item {
    color: #666666;
  }
  .text-item-col {
    padding: 0 24px;
  }
  .row-text {
    border-left: 1px solid #0000001f;
  }
  .text-y {
    padding-right: 2px;
    float: right;
    font-size: 12px;
    color: #818181;
  }
  .title-chart {
    margin: 16px 0;
    font-size: 16px;
  }
  .label-chart {
    float: right;
    font-size: 12px;
    display: flex;
    height: 24px;
    .chart-line {
      padding: 4px 8px 6px 8px;
      margin-right: 16px;
      border: 1px solid #818181;
      border-radius: 12px;
      display: flex;
    }
    .chart-bar {
      padding: 3px 15px 0 15px;
      margin-right: 16px;
      border: 1px solid #818181;
      border-radius: 12px;
      display: flex;
    }

    .custom-tooltip.custom-tooltip-list {
      padding: 10px;
      border-radius: 4px;
      width: 250px;
      background-color: rgba(0, 0, 0, 0.6);
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);

      .custom-tooltip-head {
        display: flex;
        flex-wrap: wrap;
        font-weight: bold;

        span {
          color: #ffffff;
          font-size: 16px;
          margin-right: 10px !important;

          &:last-child {
            margin-left: 20px !important;
          }
        }

        .custom-tooltip-item-icon {
          margin-right: 5px !important;
          margin-top: 8px !important;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: ghostwhite;
        }
      }

      .custom-tooltip-item {
        margin-left: 20px;
        padding: 0;
        color: #ffffff;
      }

      .custom-tooltip-item-title {
        display: flex;
        align-items: baseline;
        margin: 0;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;

        .custom-tooltip-item-text {
          &:nth-child(1) {
            width: 70px;
          }
          margin-left: 8px;
          color: #ffffff;
        }

        .custom-tooltip-item-value {
          margin: 0 0 0 16px;
          width: 50px;
          font-size: 16px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
  }
`;
